import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Box,
  Table,
  TableHead,
  TableBody
} from '@material-ui/core';
import { Checkboxes } from 'mui-rff';
import { AutoSizer, List as VirtualizedList } from 'react-virtualized';
import { ChevronRightIcon } from '../../../../core/themes/icons/ChevronRightIcon';
import { ChevronDownIcon } from '../../../../core/themes/icons/ChevronDownIcon';
import Checkbox from '@material-ui/core/Checkbox';

import { useStyles } from '../../utils/styles';

const classChevron = {
  chevron: {
    fontSize: '10px',
    color: '#757575'
  }
};

const FundInvestorSelection = ({
  fundName,
  fundId,
  investors,
  formValues,
  formRef,
  setShouldHideBackButton
}) => {
  const [open, setOpen] = useState(false);
  const styles = useStyles();

  const numberOfSelectedRows = useMemo(() => {
    const values = { ...formValues };
    return Object.values(values[`id-${fundId}`]).filter(
      entry => entry !== false
    ).length;
  }, [fundId, formValues]);

  const rowCount = investors.length;
  const calcHeight = rowCount < 10 ? `${rowCount * 30}px` : `${300}px`;

  const handleClickAll = useCallback(() => {
    let updatedValues = {};
    if (numberOfSelectedRows === rowCount) {
      Object.keys(formValues[`id-${fundId}`]).forEach(investor => {
        updatedValues = {
          ...updatedValues,
          [investor]: false
        };
      });
      formRef.change(`id-${fundId}`, updatedValues);
    } else if (numberOfSelectedRows !== rowCount) {
      investors.forEach(investor => {
        updatedValues = {
          ...updatedValues,
          [`id-${investor.investorId}`]: true
        };
      });
      formRef.change(`id-${fundId}`, updatedValues);
    }
  }, [numberOfSelectedRows, investors, rowCount, fundId, formRef, formValues]);

  useEffect(() => {
    setShouldHideBackButton(true);
  }, [setShouldHideBackButton]);

  function investorRenderer({ key, index, style }) {
    return (
      <TableRow key={key} style={style} className={styles.collapseRow}>
        <TableCell>{investors[index].investorName}</TableCell>
        <TableCell className={rowCount > 10 ? styles.cellRightScroll : ''}>
          <Checkboxes
            required={true}
            name={`id-${fundId}.id-${investors[index].investorId}`}
            data={{ label: undefined, value: true }}
            style={{ padding: '0 19px' }}
          />
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      <TableRow className={styles.mainRow}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <ChevronDownIcon style={classChevron.chevron} />
            ) : (
              <ChevronRightIcon style={classChevron.chevron} />
            )}
          </IconButton>
          {fundName}
        </TableCell>
        <TableCell>
          <Checkbox
            onClick={handleClickAll}
            checked={numberOfSelectedRows === rowCount && rowCount > 0}
            indeterminate={
              numberOfSelectedRows > 0 && numberOfSelectedRows < rowCount
            }
          />
        </TableCell>
      </TableRow>
      {open && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Investors</TableCell>
                    </TableRow>
                  </TableHead>
                  {/*Height is calculated based on the size of the list to display*/}
                  <TableBody style={{ height: calcHeight }}>
                    <AutoSizer>
                      {({ height, width }) => (
                        <VirtualizedList
                          width={width}
                          height={height}
                          rowCount={investors.length}
                          rowHeight={30}
                          rowRenderer={investorRenderer}
                        />
                      )}
                    </AutoSizer>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default FundInvestorSelection;
